"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePartialSsn = exports.validateSsn = void 0;
function validateSsn(ssn) {
    if (typeof ssn !== 'string')
        return false;
    return /^[0-9]{9}$/.test(ssn.replace(/-/g, ''));
}
exports.validateSsn = validateSsn;
function validatePartialSsn(ssn) {
    if (typeof ssn !== 'string')
        return false;
    return /^[0-9]{4}$/.test(ssn);
}
exports.validatePartialSsn = validatePartialSsn;
//# sourceMappingURL=validateSsn.js.map